import { useContext, useState } from "react";
import ImportContactsRoundedIcon from "@mui/icons-material/ImportContactsRounded";
import { useTranslation } from "react-i18next";
import StepperComponent from "../../../components/stepper/stepper";
import ApplicationUpsertForm, {
  IAddEditProviderModel,
} from "../application-upsert-form";
import { INewApplicationModel} from "../applications-model";
import pubSub, { EVENTS } from "../../../config/pubSub";
import { useService }from "../applications-service";
import { AppConfig } from "../../../context/context";
import { BorderedBox } from "../../../components/bordered-box/bordered-box";

type IProps = {
  handleClose: () => void;
  handleDone: () => void;
  model: IAddEditProviderModel;
  handleModelChange: (updatedModel: any) => void;
  handleProcessingChange: (processing: boolean) => void;
};

function getSteps() {
  return ["Name & License"];
}

function GetStepContent(
  model: IAddEditProviderModel,
  handleModelChange: (updatedModel: any) => void,
) {
  return {
    0: (
      <BorderedBox>
        <ApplicationUpsertForm  model={model} handleModelChange={handleModelChange} />
      </BorderedBox>
    ),
  };
}

const getIcons = () => {
  return {
    0: <ImportContactsRoundedIcon />,
  };
};

const AddComponent = (props: IProps) => {
  const icons = getIcons();
  const steps = getSteps();
  const { model, handleModelChange } = props;
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const { config } = useContext(AppConfig);
  const { appService } = useService();
  const { t } = useTranslation();
  /*useEffect(() => {
    const service: any = ApplicationService(config);
    setHttp(service);
  }, [config]);*/

  
  
  //const { appService } = useService();

  const stepsContent = GetStepContent(model, handleModelChange);
  const handleCancel = () => {
    props.handleClose();
  };

  const HandleDone = async () => {
    if (!appService || isProcessing) return;

    props.handleProcessingChange(true);
    setIsProcessing(true);

    const newApplicationModel: INewApplicationModel = {
      name: model[0].name
    };

    try {
      await appService.createApp(config.tenantId, newApplicationModel);
      pubSub.publish(EVENTS.ADD_ORGANIZATION, newApplicationModel);
      pubSub.publish(EVENTS.SUCCESS, t("application_is_added"));
      pubSub.publish(EVENTS.ORGANIZATIONS_LIST);
      props.handleDone();
    } catch (error: any) {
      if (error.response) {
        switch (+error.response.status) {
          case 409:
            pubSub.publish(EVENTS.PP_ERROR_ORGANIZATION_DUP, error);
            break;
          default:
            pubSub.publish(EVENTS.ERROR, 'common_error_msg');
        }
      } else {
        pubSub.publish(EVENTS.ERROR, 'common_error_msg');
      }
    } finally {
      setIsProcessing(false);
      props.handleProcessingChange(false);
    }
  };

  return (
    <StepperComponent
      icons={icons}
      steps={steps}
      isValid={model.isValid}
      stepsContent={stepsContent}
      handleCancel={handleCancel}
      handleDone={HandleDone}
      isEdit={false}
      isProcessing={isProcessing}
    />
  );
};

export default AddComponent;
